import { mediaQueryStyles, constants } from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const { colors, breakpoints } = constants;

const { BreakpointNames } = breakpoints;

export const MAX_DROPDOWN_HEIGHT = "336px";

export const rootCss = {
  display: "flex",
  justifyContent: "center",
};

export const wrappingContainerCss = {
  flex: 1,
  maxWidth: "996px",
  borderBottom: `1px solid ${colors.ui.neutral[300]}`,
  paddingTop: "63px",
  paddingBottom: "48px",
  marginRight: "24px",
  marginLeft: "24px",

  [mediaQuery.upTo("md")]: {
    marginRight: "40px",
    marginLeft: "40px",
    padding: "24px 0px 48px",
  },

  [mediaQuery.upTo(BreakpointNames.xs)]: {
    marginRight: "16px",
    marginLeft: "16px",
  },
};
